import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-2.5 w-full overflow-hidden rounded-full bg-primary/15",
      className
    )}
    {...props}>
    <ProgressPrimitive.Indicator
      className="h-full transition-all"
      style={{
        width: `${value || 0}%`,
        background: "linear-gradient(90deg, var(--result-gradient-start), var(--result-gradient-end))",
      }} />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
